export default `
attribute vec3 vertexPosition;
attribute vec3 vertexNormal;

uniform mat4 mvp;

void main() {
    gl_Position = mvp * vec4( vertexPosition, 1.0 );
}
`